import { jsx as f, Fragment as re, jsxs as Y } from "react/jsx-runtime";
import * as s from "react";
import F, { createContext as Ve, useState as ke, useContext as We } from "react";
import { c as Ue } from "./index-SYE1cn5_.js";
import { $ as Ke } from "./index-D_37ItTm.js";
import { r as se, R as Be } from "./index-2hJuj4UN.js";
import { V as pe } from "./index-C-I5rYZA.js";
function S(e, t, { checkForDefaultPrevented: o = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), o === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function $e(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function me(...e) {
  return (t) => e.forEach((o) => $e(o, t));
}
function V(...e) {
  return s.useCallback(me(...e), e);
}
function ve(e, t = []) {
  let o = [];
  function n(a, c) {
    const u = s.createContext(c), d = o.length;
    o = [...o, c];
    function i(E) {
      const { scope: y, children: h, ...T } = E, m = (y == null ? void 0 : y[e][d]) || u, l = s.useMemo(() => T, Object.values(T));
      return /* @__PURE__ */ f(m.Provider, { value: l, children: h });
    }
    function p(E, y) {
      const h = (y == null ? void 0 : y[e][d]) || u, T = s.useContext(h);
      if (T) return T;
      if (c !== void 0) return c;
      throw new Error(`\`${E}\` must be used within \`${a}\``);
    }
    return i.displayName = a + "Provider", [i, p];
  }
  const r = () => {
    const a = o.map((c) => s.createContext(c));
    return function(u) {
      const d = (u == null ? void 0 : u[e]) || a;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...u, [e]: d } }),
        [u, d]
      );
    };
  };
  return r.scopeName = e, [n, ze(r, ...t)];
}
function ze(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const o = () => {
    const n = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const c = n.reduce((u, { useScope: d, scopeName: i }) => {
        const E = d(a)[`__scope${i}`];
        return { ...u, ...E };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    };
  };
  return o.scopeName = t.scopeName, o;
}
var H = s.forwardRef((e, t) => {
  const { children: o, ...n } = e, r = s.Children.toArray(o), a = r.find(He);
  if (a) {
    const c = a.props.children, u = r.map((d) => d === a ? s.Children.count(c) > 1 ? s.Children.only(null) : s.isValidElement(c) ? c.props.children : null : d);
    return /* @__PURE__ */ f(Q, { ...n, ref: t, children: s.isValidElement(c) ? s.cloneElement(c, void 0, u) : null });
  }
  return /* @__PURE__ */ f(Q, { ...n, ref: t, children: o });
});
H.displayName = "Slot";
var Q = s.forwardRef((e, t) => {
  const { children: o, ...n } = e;
  if (s.isValidElement(o)) {
    const r = Ye(o);
    return s.cloneElement(o, {
      ...Xe(n, o.props),
      // @ts-ignore
      ref: t ? me(t, r) : r
    });
  }
  return s.Children.count(o) > 1 ? s.Children.only(null) : null;
});
Q.displayName = "SlotClone";
var je = ({ children: e }) => /* @__PURE__ */ f(re, { children: e });
function He(e) {
  return s.isValidElement(e) && e.type === je;
}
function Xe(e, t) {
  const o = { ...t };
  for (const n in t) {
    const r = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? r && a ? o[n] = (...u) => {
      a(...u), r(...u);
    } : r && (o[n] = r) : n === "style" ? o[n] = { ...r, ...a } : n === "className" && (o[n] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...o };
}
function Ye(e) {
  var n, r;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
function qe(e) {
  const t = e + "CollectionProvider", [o, n] = ve(t), [r, a] = o(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), c = (h) => {
    const { scope: T, children: m } = h, l = F.useRef(null), P = F.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ f(r, { scope: T, itemMap: P, collectionRef: l, children: m });
  };
  c.displayName = t;
  const u = e + "CollectionSlot", d = F.forwardRef(
    (h, T) => {
      const { scope: m, children: l } = h, P = a(u, m), w = V(T, P.collectionRef);
      return /* @__PURE__ */ f(H, { ref: w, children: l });
    }
  );
  d.displayName = u;
  const i = e + "CollectionItemSlot", p = "data-radix-collection-item", E = F.forwardRef(
    (h, T) => {
      const { scope: m, children: l, ...P } = h, w = F.useRef(null), b = V(T, w), R = a(i, m);
      return F.useEffect(() => (R.itemMap.set(w, { ref: w, ...P }), () => void R.itemMap.delete(w))), /* @__PURE__ */ f(H, { [p]: "", ref: b, children: l });
    }
  );
  E.displayName = i;
  function y(h) {
    const T = a(e + "CollectionConsumer", h);
    return F.useCallback(() => {
      const l = T.collectionRef.current;
      if (!l) return [];
      const P = Array.from(l.querySelectorAll(`[${p}]`));
      return Array.from(T.itemMap.values()).sort(
        (R, x) => P.indexOf(R.ref.current) - P.indexOf(x.ref.current)
      );
    }, [T.collectionRef, T.itemMap]);
  }
  return [
    { Provider: c, Slot: d, ItemSlot: E },
    y,
    n
  ];
}
var Ze = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], D = Ze.reduce((e, t) => {
  const o = s.forwardRef((n, r) => {
    const { asChild: a, ...c } = n, u = a ? H : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(u, { ...c, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Ee(e, t) {
  e && se.flushSync(() => e.dispatchEvent(t));
}
function O(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => (...o) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...o);
  }, []);
}
function Ge(e, t = globalThis == null ? void 0 : globalThis.document) {
  const o = O(e);
  s.useEffect(() => {
    const n = (r) => {
      r.key === "Escape" && o(r);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [o, t]);
}
var Je = "DismissableLayer", ee = "dismissableLayer.update", Qe = "dismissableLayer.pointerDownOutside", et = "dismissableLayer.focusOutside", ue, we = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Te = s.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: o = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: r,
      onFocusOutside: a,
      onInteractOutside: c,
      onDismiss: u,
      ...d
    } = e, i = s.useContext(we), [p, E] = s.useState(null), y = (p == null ? void 0 : p.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = s.useState({}), T = V(t, (C) => E(C)), m = Array.from(i.layers), [l] = [...i.layersWithOutsidePointerEventsDisabled].slice(-1), P = m.indexOf(l), w = p ? m.indexOf(p) : -1, b = i.layersWithOutsidePointerEventsDisabled.size > 0, R = w >= P, x = nt((C) => {
      const _ = C.target, A = [...i.branches].some((L) => L.contains(_));
      !R || A || (r == null || r(C), c == null || c(C), C.defaultPrevented || u == null || u());
    }, y), g = ot((C) => {
      const _ = C.target;
      [...i.branches].some((L) => L.contains(_)) || (a == null || a(C), c == null || c(C), C.defaultPrevented || u == null || u());
    }, y);
    return Ge((C) => {
      w === i.layers.size - 1 && (n == null || n(C), !C.defaultPrevented && u && (C.preventDefault(), u()));
    }, y), s.useEffect(() => {
      if (p)
        return o && (i.layersWithOutsidePointerEventsDisabled.size === 0 && (ue = y.body.style.pointerEvents, y.body.style.pointerEvents = "none"), i.layersWithOutsidePointerEventsDisabled.add(p)), i.layers.add(p), le(), () => {
          o && i.layersWithOutsidePointerEventsDisabled.size === 1 && (y.body.style.pointerEvents = ue);
        };
    }, [p, y, o, i]), s.useEffect(() => () => {
      p && (i.layers.delete(p), i.layersWithOutsidePointerEventsDisabled.delete(p), le());
    }, [p, i]), s.useEffect(() => {
      const C = () => h({});
      return document.addEventListener(ee, C), () => document.removeEventListener(ee, C);
    }, []), /* @__PURE__ */ f(
      D.div,
      {
        ...d,
        ref: T,
        style: {
          pointerEvents: b ? R ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: S(e.onFocusCapture, g.onFocusCapture),
        onBlurCapture: S(e.onBlurCapture, g.onBlurCapture),
        onPointerDownCapture: S(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Te.displayName = Je;
var tt = "DismissableLayerBranch", ye = s.forwardRef((e, t) => {
  const o = s.useContext(we), n = s.useRef(null), r = V(t, n);
  return s.useEffect(() => {
    const a = n.current;
    if (a)
      return o.branches.add(a), () => {
        o.branches.delete(a);
      };
  }, [o.branches]), /* @__PURE__ */ f(D.div, { ...e, ref: r });
});
ye.displayName = tt;
function nt(e, t = globalThis == null ? void 0 : globalThis.document) {
  const o = O(e), n = s.useRef(!1), r = s.useRef(() => {
  });
  return s.useEffect(() => {
    const a = (u) => {
      if (u.target && !n.current) {
        let d = function() {
          he(
            Qe,
            o,
            i,
            { discrete: !0 }
          );
        };
        const i = { originalEvent: u };
        u.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = d, t.addEventListener("click", r.current, { once: !0 })) : d();
      } else
        t.removeEventListener("click", r.current);
      n.current = !1;
    }, c = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", a), t.removeEventListener("click", r.current);
    };
  }, [t, o]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function ot(e, t = globalThis == null ? void 0 : globalThis.document) {
  const o = O(e), n = s.useRef(!1);
  return s.useEffect(() => {
    const r = (a) => {
      a.target && !n.current && he(et, o, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, o]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function le() {
  const e = new CustomEvent(ee);
  document.dispatchEvent(e);
}
function he(e, t, o, { discrete: n }) {
  const r = o.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: o });
  t && r.addEventListener(e, t, { once: !0 }), n ? Ee(r, a) : r.dispatchEvent(a);
}
var rt = Te, st = ye, X = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
}, it = "Portal", Ce = s.forwardRef((e, t) => {
  var u;
  const { container: o, ...n } = e, [r, a] = s.useState(!1);
  X(() => a(!0), []);
  const c = o || r && ((u = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : u.body);
  return c ? Be.createPortal(/* @__PURE__ */ f(D.div, { ...n, ref: t }), c) : null;
});
Ce.displayName = it;
function at(e, t) {
  return s.useReducer((o, n) => t[o][n] ?? o, e);
}
var Pe = (e) => {
  const { present: t, children: o } = e, n = ct(t), r = typeof o == "function" ? o({ present: n.isPresent }) : s.Children.only(o), a = V(n.ref, ut(r));
  return typeof o == "function" || n.isPresent ? s.cloneElement(r, { ref: a }) : null;
};
Pe.displayName = "Presence";
function ct(e) {
  const [t, o] = s.useState(), n = s.useRef({}), r = s.useRef(e), a = s.useRef("none"), c = e ? "mounted" : "unmounted", [u, d] = at(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const i = z(n.current);
    a.current = u === "mounted" ? i : "none";
  }, [u]), X(() => {
    const i = n.current, p = r.current;
    if (p !== e) {
      const y = a.current, h = z(i);
      e ? d("MOUNT") : h === "none" || (i == null ? void 0 : i.display) === "none" ? d("UNMOUNT") : d(p && y !== h ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, d]), X(() => {
    if (t) {
      const i = (E) => {
        const h = z(n.current).includes(E.animationName);
        E.target === t && h && se.flushSync(() => d("ANIMATION_END"));
      }, p = (E) => {
        E.target === t && (a.current = z(n.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", i), t.addEventListener("animationend", i), () => {
        t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", i), t.removeEventListener("animationend", i);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(u),
    ref: s.useCallback((i) => {
      i && (n.current = getComputedStyle(i)), o(i);
    }, [])
  };
}
function z(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function ut(e) {
  var n, r;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
function lt({
  prop: e,
  defaultProp: t,
  onChange: o = () => {
  }
}) {
  const [n, r] = dt({ defaultProp: t, onChange: o }), a = e !== void 0, c = a ? e : n, u = O(o), d = s.useCallback(
    (i) => {
      if (a) {
        const E = typeof i == "function" ? i(e) : i;
        E !== e && u(E);
      } else
        r(i);
    },
    [a, e, r, u]
  );
  return [c, d];
}
function dt({
  defaultProp: e,
  onChange: t
}) {
  const o = s.useState(e), [n] = o, r = s.useRef(n), a = O(t);
  return s.useEffect(() => {
    r.current !== n && (a(n), r.current = n);
  }, [n, r, a]), o;
}
var ie = "ToastProvider", [ae, ft, pt] = qe("Toast"), [be, $t] = ve("Toast", [pt]), [mt, q] = be(ie), Re = (e) => {
  const {
    __scopeToast: t,
    label: o = "Notification",
    duration: n = 5e3,
    swipeDirection: r = "right",
    swipeThreshold: a = 50,
    children: c
  } = e, [u, d] = s.useState(null), [i, p] = s.useState(0), E = s.useRef(!1), y = s.useRef(!1);
  return o.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${ie}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ f(ae.Provider, { scope: t, children: /* @__PURE__ */ f(
    mt,
    {
      scope: t,
      label: o,
      duration: n,
      swipeDirection: r,
      swipeThreshold: a,
      toastCount: i,
      viewport: u,
      onViewportChange: d,
      onToastAdd: s.useCallback(() => p((h) => h + 1), []),
      onToastRemove: s.useCallback(() => p((h) => h - 1), []),
      isFocusedToastEscapeKeyDownRef: E,
      isClosePausedRef: y,
      children: c
    }
  ) });
};
Re.displayName = ie;
var xe = "ToastViewport", vt = ["F8"], te = "toast.viewportPause", ne = "toast.viewportResume", ge = s.forwardRef(
  (e, t) => {
    const {
      __scopeToast: o,
      hotkey: n = vt,
      label: r = "Notifications ({hotkey})",
      ...a
    } = e, c = q(xe, o), u = ft(o), d = s.useRef(null), i = s.useRef(null), p = s.useRef(null), E = s.useRef(null), y = V(t, E, c.onViewportChange), h = n.join("+").replace(/Key/g, "").replace(/Digit/g, ""), T = c.toastCount > 0;
    s.useEffect(() => {
      const l = (P) => {
        var b;
        n.every((R) => P[R] || P.code === R) && ((b = E.current) == null || b.focus());
      };
      return document.addEventListener("keydown", l), () => document.removeEventListener("keydown", l);
    }, [n]), s.useEffect(() => {
      const l = d.current, P = E.current;
      if (T && l && P) {
        const w = () => {
          if (!c.isClosePausedRef.current) {
            const g = new CustomEvent(te);
            P.dispatchEvent(g), c.isClosePausedRef.current = !0;
          }
        }, b = () => {
          if (c.isClosePausedRef.current) {
            const g = new CustomEvent(ne);
            P.dispatchEvent(g), c.isClosePausedRef.current = !1;
          }
        }, R = (g) => {
          !l.contains(g.relatedTarget) && b();
        }, x = () => {
          l.contains(document.activeElement) || b();
        };
        return l.addEventListener("focusin", w), l.addEventListener("focusout", R), l.addEventListener("pointermove", w), l.addEventListener("pointerleave", x), window.addEventListener("blur", w), window.addEventListener("focus", b), () => {
          l.removeEventListener("focusin", w), l.removeEventListener("focusout", R), l.removeEventListener("pointermove", w), l.removeEventListener("pointerleave", x), window.removeEventListener("blur", w), window.removeEventListener("focus", b);
        };
      }
    }, [T, c.isClosePausedRef]);
    const m = s.useCallback(
      ({ tabbingDirection: l }) => {
        const w = u().map((b) => {
          const R = b.ref.current, x = [R, ...Ot(R)];
          return l === "forwards" ? x : x.reverse();
        });
        return (l === "forwards" ? w.reverse() : w).flat();
      },
      [u]
    );
    return s.useEffect(() => {
      const l = E.current;
      if (l) {
        const P = (w) => {
          var x, g, C;
          const b = w.altKey || w.ctrlKey || w.metaKey;
          if (w.key === "Tab" && !b) {
            const _ = document.activeElement, A = w.shiftKey;
            if (w.target === l && A) {
              (x = i.current) == null || x.focus();
              return;
            }
            const M = m({ tabbingDirection: A ? "backwards" : "forwards" }), K = M.findIndex((v) => v === _);
            J(M.slice(K + 1)) ? w.preventDefault() : A ? (g = i.current) == null || g.focus() : (C = p.current) == null || C.focus();
          }
        };
        return l.addEventListener("keydown", P), () => l.removeEventListener("keydown", P);
      }
    }, [u, m]), /* @__PURE__ */ Y(
      st,
      {
        ref: d,
        role: "region",
        "aria-label": r.replace("{hotkey}", h),
        tabIndex: -1,
        style: { pointerEvents: T ? void 0 : "none" },
        children: [
          T && /* @__PURE__ */ f(
            oe,
            {
              ref: i,
              onFocusFromOutsideViewport: () => {
                const l = m({
                  tabbingDirection: "forwards"
                });
                J(l);
              }
            }
          ),
          /* @__PURE__ */ f(ae.Slot, { scope: o, children: /* @__PURE__ */ f(D.ol, { tabIndex: -1, ...a, ref: y }) }),
          T && /* @__PURE__ */ f(
            oe,
            {
              ref: p,
              onFocusFromOutsideViewport: () => {
                const l = m({
                  tabbingDirection: "backwards"
                });
                J(l);
              }
            }
          )
        ]
      }
    );
  }
);
ge.displayName = xe;
var Se = "ToastFocusProxy", oe = s.forwardRef(
  (e, t) => {
    const { __scopeToast: o, onFocusFromOutsideViewport: n, ...r } = e, a = q(Se, o);
    return /* @__PURE__ */ f(
      pe,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...r,
        ref: t,
        style: { position: "fixed" },
        onFocus: (c) => {
          var i;
          const u = c.relatedTarget;
          !((i = a.viewport) != null && i.contains(u)) && n();
        }
      }
    );
  }
);
oe.displayName = Se;
var Z = "Toast", Et = "toast.swipeStart", wt = "toast.swipeMove", Tt = "toast.swipeCancel", yt = "toast.swipeEnd", Ne = s.forwardRef(
  (e, t) => {
    const { forceMount: o, open: n, defaultOpen: r, onOpenChange: a, ...c } = e, [u = !0, d] = lt({
      prop: n,
      defaultProp: r,
      onChange: a
    });
    return /* @__PURE__ */ f(Pe, { present: o || u, children: /* @__PURE__ */ f(
      Pt,
      {
        open: u,
        ...c,
        ref: t,
        onClose: () => d(!1),
        onPause: O(e.onPause),
        onResume: O(e.onResume),
        onSwipeStart: S(e.onSwipeStart, (i) => {
          i.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: S(e.onSwipeMove, (i) => {
          const { x: p, y: E } = i.detail.delta;
          i.currentTarget.setAttribute("data-swipe", "move"), i.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${p}px`), i.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${E}px`);
        }),
        onSwipeCancel: S(e.onSwipeCancel, (i) => {
          i.currentTarget.setAttribute("data-swipe", "cancel"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), i.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), i.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: S(e.onSwipeEnd, (i) => {
          const { x: p, y: E } = i.detail.delta;
          i.currentTarget.setAttribute("data-swipe", "end"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), i.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), i.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${p}px`), i.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${E}px`), d(!1);
        })
      }
    ) });
  }
);
Ne.displayName = Z;
var [ht, Ct] = be(Z, {
  onClose() {
  }
}), Pt = s.forwardRef(
  (e, t) => {
    const {
      __scopeToast: o,
      type: n = "foreground",
      duration: r,
      open: a,
      onClose: c,
      onEscapeKeyDown: u,
      onPause: d,
      onResume: i,
      onSwipeStart: p,
      onSwipeMove: E,
      onSwipeCancel: y,
      onSwipeEnd: h,
      ...T
    } = e, m = q(Z, o), [l, P] = s.useState(null), w = V(t, (v) => P(v)), b = s.useRef(null), R = s.useRef(null), x = r || m.duration, g = s.useRef(0), C = s.useRef(x), _ = s.useRef(0), { onToastAdd: A, onToastRemove: L } = m, k = O(() => {
      var N;
      (l == null ? void 0 : l.contains(document.activeElement)) && ((N = m.viewport) == null || N.focus()), c();
    }), M = s.useCallback(
      (v) => {
        !v || v === 1 / 0 || (window.clearTimeout(_.current), g.current = (/* @__PURE__ */ new Date()).getTime(), _.current = window.setTimeout(k, v));
      },
      [k]
    );
    s.useEffect(() => {
      const v = m.viewport;
      if (v) {
        const N = () => {
          M(C.current), i == null || i();
        }, I = () => {
          const W = (/* @__PURE__ */ new Date()).getTime() - g.current;
          C.current = C.current - W, window.clearTimeout(_.current), d == null || d();
        };
        return v.addEventListener(te, I), v.addEventListener(ne, N), () => {
          v.removeEventListener(te, I), v.removeEventListener(ne, N);
        };
      }
    }, [m.viewport, x, d, i, M]), s.useEffect(() => {
      a && !m.isClosePausedRef.current && M(x);
    }, [a, x, m.isClosePausedRef, M]), s.useEffect(() => (A(), () => L()), [A, L]);
    const K = s.useMemo(() => l ? Ie(l) : null, [l]);
    return m.viewport ? /* @__PURE__ */ Y(re, { children: [
      K && /* @__PURE__ */ f(
        bt,
        {
          __scopeToast: o,
          role: "status",
          "aria-live": n === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: K
        }
      ),
      /* @__PURE__ */ f(ht, { scope: o, onClose: k, children: se.createPortal(
        /* @__PURE__ */ f(ae.ItemSlot, { scope: o, children: /* @__PURE__ */ f(
          rt,
          {
            asChild: !0,
            onEscapeKeyDown: S(u, () => {
              m.isFocusedToastEscapeKeyDownRef.current || k(), m.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ f(
              D.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": m.swipeDirection,
                ...T,
                ref: w,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: S(e.onKeyDown, (v) => {
                  v.key === "Escape" && (u == null || u(v.nativeEvent), v.nativeEvent.defaultPrevented || (m.isFocusedToastEscapeKeyDownRef.current = !0, k()));
                }),
                onPointerDown: S(e.onPointerDown, (v) => {
                  v.button === 0 && (b.current = { x: v.clientX, y: v.clientY });
                }),
                onPointerMove: S(e.onPointerMove, (v) => {
                  if (!b.current) return;
                  const N = v.clientX - b.current.x, I = v.clientY - b.current.y, W = !!R.current, U = ["left", "right"].includes(m.swipeDirection), B = ["left", "up"].includes(m.swipeDirection) ? Math.min : Math.max, Me = U ? B(0, N) : 0, Fe = U ? 0 : B(0, I), G = v.pointerType === "touch" ? 10 : 2, $ = { x: Me, y: Fe }, ce = { originalEvent: v, delta: $ };
                  W ? (R.current = $, j(wt, E, ce, {
                    discrete: !1
                  })) : de($, m.swipeDirection, G) ? (R.current = $, j(Et, p, ce, {
                    discrete: !1
                  }), v.target.setPointerCapture(v.pointerId)) : (Math.abs(N) > G || Math.abs(I) > G) && (b.current = null);
                }),
                onPointerUp: S(e.onPointerUp, (v) => {
                  const N = R.current, I = v.target;
                  if (I.hasPointerCapture(v.pointerId) && I.releasePointerCapture(v.pointerId), R.current = null, b.current = null, N) {
                    const W = v.currentTarget, U = { originalEvent: v, delta: N };
                    de(N, m.swipeDirection, m.swipeThreshold) ? j(yt, h, U, {
                      discrete: !0
                    }) : j(
                      Tt,
                      y,
                      U,
                      {
                        discrete: !0
                      }
                    ), W.addEventListener("click", (B) => B.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        m.viewport
      ) })
    ] }) : null;
  }
), bt = (e) => {
  const { __scopeToast: t, children: o, ...n } = e, r = q(Z, t), [a, c] = s.useState(!1), [u, d] = s.useState(!1);
  return _t(() => c(!0)), s.useEffect(() => {
    const i = window.setTimeout(() => d(!0), 1e3);
    return () => window.clearTimeout(i);
  }, []), u ? null : /* @__PURE__ */ f(Ce, { asChild: !0, children: /* @__PURE__ */ f(pe, { ...n, children: a && /* @__PURE__ */ Y(re, { children: [
    r.label,
    " ",
    o
  ] }) }) });
}, Rt = "ToastTitle", xt = s.forwardRef(
  (e, t) => {
    const { __scopeToast: o, ...n } = e;
    return /* @__PURE__ */ f(D.div, { ...n, ref: t });
  }
);
xt.displayName = Rt;
var gt = "ToastDescription", St = s.forwardRef(
  (e, t) => {
    const { __scopeToast: o, ...n } = e;
    return /* @__PURE__ */ f(D.div, { ...n, ref: t });
  }
);
St.displayName = gt;
var _e = "ToastAction", Nt = s.forwardRef(
  (e, t) => {
    const { altText: o, ...n } = e;
    return o.trim() ? /* @__PURE__ */ f(De, { altText: o, asChild: !0, children: /* @__PURE__ */ f(Oe, { ...n, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${_e}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
Nt.displayName = _e;
var Ae = "ToastClose", Oe = s.forwardRef(
  (e, t) => {
    const { __scopeToast: o, ...n } = e, r = Ct(Ae, o);
    return /* @__PURE__ */ f(De, { asChild: !0, children: /* @__PURE__ */ f(
      D.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: S(e.onClick, r.onClose)
      }
    ) });
  }
);
Oe.displayName = Ae;
var De = s.forwardRef((e, t) => {
  const { __scopeToast: o, altText: n, ...r } = e;
  return /* @__PURE__ */ f(
    D.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": n || void 0,
      ...r,
      ref: t
    }
  );
});
function Ie(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((n) => {
    if (n.nodeType === n.TEXT_NODE && n.textContent && t.push(n.textContent), At(n)) {
      const r = n.ariaHidden || n.hidden || n.style.display === "none", a = n.dataset.radixToastAnnounceExclude === "";
      if (!r)
        if (a) {
          const c = n.dataset.radixToastAnnounceAlt;
          c && t.push(c);
        } else
          t.push(...Ie(n));
    }
  }), t;
}
function j(e, t, o, { discrete: n }) {
  const r = o.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: o });
  t && r.addEventListener(e, t, { once: !0 }), n ? Ee(r, a) : r.dispatchEvent(a);
}
var de = (e, t, o = 0) => {
  const n = Math.abs(e.x), r = Math.abs(e.y), a = n > r;
  return t === "left" || t === "right" ? a && n > o : !a && r > o;
};
function _t(e = () => {
}) {
  const t = O(e);
  X(() => {
    let o = 0, n = 0;
    return o = window.requestAnimationFrame(() => n = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(o), window.cancelAnimationFrame(n);
    };
  }, [t]);
}
function At(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Ot(e) {
  const t = [], o = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const r = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || r ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; o.nextNode(); ) t.push(o.currentNode);
  return t;
}
function J(e) {
  const t = document.activeElement;
  return e.some((o) => o === t ? !0 : (o.focus(), document.activeElement !== t));
}
var Dt = Re, It = ge, Lt = Ne;
const Mt = "_toastViewport_1wzbl_1", fe = {
  toastViewport: Mt,
  "toastViewport--top": "_toastViewport--top_1wzbl_19",
  "toastViewport--top-right": "_toastViewport--top-right_1wzbl_25",
  "toastViewport--top-left": "_toastViewport--top-left_1wzbl_30",
  "toastViewport--bottom": "_toastViewport--bottom_1wzbl_35",
  "toastViewport--bottom-right": "_toastViewport--bottom-right_1wzbl_41",
  "toastViewport--bottom-left": "_toastViewport--bottom-left_1wzbl_46"
}, Ft = ({ position: e = "top" }) => /* @__PURE__ */ f(
  It,
  {
    className: Ue(
      fe.toastViewport,
      fe[`toastViewport--${e}`]
    )
  }
), Le = Ve(void 0);
function zt({
  children: e,
  toastPosition: t = "top"
}) {
  const [o, n] = ke([]), r = (a) => {
    n((c) => [...c, a]);
  };
  return /* @__PURE__ */ f(Le.Provider, { value: { addToast: r }, children: /* @__PURE__ */ Y(Dt, { children: [
    e,
    o.map((a, c) => /* @__PURE__ */ f(Ke, { children: a }, c)),
    /* @__PURE__ */ f(Ft, { position: t })
  ] }) });
}
function jt() {
  const e = We(Le);
  if (!e)
    throw new Error(
      "useToastContext must be used within a ToastContextProvider"
    );
  return e;
}
const Ht = ({ children: e }) => /* @__PURE__ */ f(Lt, { children: e });
export {
  zt as T,
  Ht as a,
  jt as u
};
